import React, {useState, useEffect} from "react";

import RegisterContent from "../content/RegisterContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

import { Helmet } from "react-helmet-async";
import LoadingBar from 'react-top-loading-bar';

function Register() {

    const [progress, setProgress] = useState(0);
        
    useEffect(()=>{
        setProgress(100);
    },[])
    return(
        <>
        <Helmet>
            <title>Register | Suvivah - Create Your Matrimonial Profile</title>

            <meta
                name="description"
                content="Create your Suvivah matrimonial profile and begin your journey towards an ideal marriage."
            />

            <meta
                name="keywords"
                content="Register Suvivah, Matrimony Registration, Marriage Registration, Bengali Matrimony"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />

            <link rel="canonical" href="https://suvivah.org/register" />

            <meta property="og:type" content="website" />
            <meta property="og:title" content="Register | Suvivah" />
            <meta property="og:description" content="Create your matrimonial profile with Suvivah." />
            <meta property="og:url" content="https://suvivah.org/register" />
            <meta property="og:image" content="https://suvivah.org/images/logo.png" />

            <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

        <Navbar />
        <RegisterContent/>
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <Footer />        
        </>
    );
}

export default Register;